import { withLiteObserverAndTheme } from "../../core/et3-enhanced-render";
import getCorePersonalStore from "../../stores/core/core-personal-store";
import i18n from "../../constants/i18n";
import getDashBoardStore from "../../stores/dashboard-store";
import SideBarStat from "./SideBarStat";

const KhattabatCapacity = withLiteObserverAndTheme(() => {
  const isManualKhattabaAdmin = getCorePersonalStore().isManualKhattabaAdmin.get();
  const khattabatCapacity = getDashBoardStore().khattabatAdminCapacity.get();

  return isManualKhattabaAdmin ? (
    <SideBarStat label={i18n.get("CAPACITY")} value={`${khattabatCapacity}`} />
  ) : null;
});
export default KhattabatCapacity;
